
import { getDay } from "date-fns";
import { isBefore } from "date-fns";
import { UnavailableTimeSlot } from "@/hooks/calendar/types";
import { CalendarSettings } from "@/lib/supabase";

export const useTimeSlotAvailability = (settings: CalendarSettings) => {
  const isTimeSlotUnavailable = (date: Date, hour: number): boolean => {
    if (!settings.unavailableSlots || Object.keys(settings.unavailableSlots).length === 0) {
      return false;
    }

    // Ottieni il giorno della settimana (1-7, dove 1 è lunedì)
    let dayOfWeek = getDay(date);
    // Converti da formato JavaScript (0-6, dove 0 è domenica) a formato nostro (1-7, dove 1 è lunedì)
    dayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    // Converti il giorno della settimana in una stringa per accedere alle fasce orarie
    const dayKey = dayOfWeek.toString();
    
    // Verifica se ci sono fasce orarie non disponibili per questo giorno
    const timeSlots = settings.unavailableSlots[dayKey];
    
    console.log(`[DEBUG] Verificando slot non disponibili per giorno ${dayKey}, ora ${hour}`);
    console.log(`[DEBUG] Fasce trovate: ${JSON.stringify(timeSlots)}`);
    
    if (timeSlots && timeSlots.length > 0) {
      // Verifica se l'ora corrente rientra in uno degli slot non disponibili
      return timeSlots.some(
        (slot: UnavailableTimeSlot) => hour >= slot.start && hour < slot.end
      );
    }
    
    return false;
  };

  const isTimeSlotInPast = (date: Date, hour: number): boolean => {
    const now = new Date();
    const timeSlotDate = new Date(date);
    timeSlotDate.setHours(hour, 0, 0, 0);

    return isBefore(timeSlotDate, now);
  };

  return {
    isTimeSlotUnavailable,
    isTimeSlotInPast
  };
};
